module.exports = __webpack_public_path__ + "static/media/champion_icon.e4c5919f.png";